/**
 * Application route paths
 * Centralized route definitions for type-safe navigation
 */
export const ROUTES = {
  // Public routes
  LOGIN: '/login',
  SIGNUP: '/signup',

  // Customer selection
  SELECT_CUSTOMER: '/select-customer',

  // Protected routes
  DASHBOARD: '/dashboard',
  SERVICE_CATALOG: '/service-catalog',
  SERVICE_USAGE: '/service-usage',
  CHANGE_IMPACT: '/change-impact',
  WHATS_NEW: '/whats-new',
  GENERATE_REPORT: '/generate-report',

  // Admin routes
  USER_MANAGEMENT: '/user-management',
};
